// ------------------------------------
// Constants
// ------------------------------------
export const SET_BODY_STYLE_OVERFLOW = 'SET_BODY_STYLE_OVERFLOW';
export const SET_ARIA_HIDDEN_FOR_POPUP = 'SET_ARIA_HIDDEN_FOR_POPUP';


export function setBodyStyleOverflow(overflowProperty) {
	return {
		type: SET_BODY_STYLE_OVERFLOW,
		overflowProperty,
	};
}

export function setAriaHiddenForPopup(ariaHiddenProperty) {
	return {
		type: SET_ARIA_HIDDEN_FOR_POPUP,
		ariaHiddenProperty,
	};
}



// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_BODY_STYLE_OVERFLOW]: (state, action) => {
		document.body.style.overflow = action.overflowProperty;
		return (state);
	},
	[SET_ARIA_HIDDEN_FOR_POPUP]: (state, action) => {
		document.getElementById('leo-content').setAttribute('aria-hidden', !action.ariaHiddenProperty);
		document.getElementById('leo-popup').setAttribute('aria-hidden', action.ariaHiddenProperty);
		return (state);
	},
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
